import React, {Component} from 'react';
import {v4 as uuidv4} from 'uuid';
import bootstrap from 'bootstrap/dist/js/bootstrap.min';
import {defaultErrorHandler} from '../../context/context';
import fieldService from '../../services/field-service';
import fieldConditionService from '../../services/field-condition-service';
import SubSection from '../../libs/react-components-admin/section/sub-section';
import DraggableList from '../common/draggable-list';
import FormItem from './form-item';

export default class FormItems extends Component {

  constructor(props) {
    super(props);
    const model = props.model || [];
    this.state = {
      conditions: props.conditions,
      model: model,
    };
  }

  static getDerivedStateFromProps(nextProps, prevState) {
    return prevState.conditions === nextProps.conditions ?
      null :
      {conditions: nextProps.conditions};
  }

  updateModel(model) {
    return new Promise(resolve => {
      this.setState(
        {model: model},
        () => {
          this.props.onChange(this.state.model);
          resolve();
        }
      );
    });
  }

  updateModelWithReRender(model) {
    const reRenderPromise = new Promise(resolve => this.setState(
      {model: null},
      () => resolve()
    ));
    return reRenderPromise.then(() => this.updateModel(model));
  }

  addField() {
    this.updateModel([...this.state.model, {id: uuidv4(), fieldType: 'TEXT_FIELD'}])
      .then(() => new Promise((resolve, reject) => setTimeout(
        () => {
          try {
            this.openFieldModal(this.state.model.length - 1);
            resolve();
          } catch (err) {
            reject(err);
          }
        },
        200
      )))
      .catch(defaultErrorHandler);
  }

  openFieldModal(index) {
    const element = document.getElementById('field' + index);
    new bootstrap.Modal(element, {focus: true}).show();
  }

  cloneField(index) {
    const model = this.state.model.reduce(
      (result, field, i) => {
        result.push(field);
        if (i === index) {
          result.push({...field, id: uuidv4()});
        }
        return result;
      },
      []
    );
    this.updateModelWithReRender(model).catch(defaultErrorHandler);
  }

  removeField(index) {
    this.updateModelWithReRender(this.state.model.filter((field, i) => i !== index))
      .catch(defaultErrorHandler);
  }

  render() {
    const renderListItem = (field, i) => {
      const fieldUsedInCondition = fieldConditionService.usedInCondition(field.id, this.state.conditions);
      return <div className="row">
        <div className="col" style={{ cursor: 'move' }}>
          {fieldService.fieldDescription(field)}
          {fieldUsedInCondition &&
          <div className="form-text">Used in condition, cannot be deleted</div>
          }
        </div>
        <div className="col-auto">
          <button type="button"
                  className="btn btn-primary btn-sm px-3"
                  onClick={() => this.openFieldModal(i)}>
            Edit
          </button>
        </div>
        <div className="col-auto">
          <button type="button"
                  className="btn btn-secondary btn-sm px-3"
                  onClick={() => this.cloneField(i)}>
            Clone
          </button>
        </div>
        <div className="col-auto">
          <button type="button"
                  className="btn btn-danger btn-sm"
                  onClick={() => this.removeField(i)}
                  disabled={fieldUsedInCondition}>
            <span className="material-icons align-middle" style={{fontSize: '1.1rem'}}>delete</span>
          </button>
        </div>
      </div>;
    };

    const listFooter = <li className="list-group-item">
      <div className="row">
        <div className="col">
        </div>
        <div className="col-auto">
          <button type="button"
                  className="btn btn-success btn-sm"
                  onClick={() => this.addField()}>
            {!this.state.model || this.state.model.length === 0 ?
              <span>Add field</span> :
              <span className="material-icons align-middle" style={{fontSize: '1.1rem'}}>add</span>
            }
          </button>
        </div>
      </div>
    </li>;

    return <SubSection className="mt-3" title="Form items (title, fields etc.)">
      {this.state.model != null &&
      <>
        <DraggableList value={this.state.model}
                       onChange={v => this.updateModelWithReRender(v)}
                       itemRenderer={(value, i) => renderListItem(value, i)}
                       footer={listFooter}/>
        {this.state.model.map((item, i) =>
          <FormItem key={i}
                    id={'field' + i}
                    conditions={this.state.conditions}
                    model={item}
                    onChange={value =>
                      this.updateModel(this.state.model.map((v, j) => j === i ? value : v))
                    }/>
        )}
      </>
      }
    </SubSection>;
  }

}
